import request from 'Request'

const CustomLinkService = {
  async get({ id }) {
    return request.get('/customlink/get', { params: { id } })
  },
  async create({ data }) {
    return request.post('/customlink/create', { data })
  },
  async update({ id, data }) {
    data = { ...data, id }
    return request.post(`/customlink/update`, { data })
  },
  async deactivate({ id, data }) {
    data = { ...data, id }
    return request.post('/customlink/deactivate', { data })
  },
  async getLink({ id }) {
    return request.get('/customlink/get/link', { params: { id } })
  },
  async duplicate({ id }) {
    return request.get('/customlink/duplicate', { params: { id } })
  },
  async getLinks({ ids }) {
    return request.post('/customlink/get/links', { data: ids })
  }
}

export default CustomLinkService
